import React from 'react';
import { Navigate, useSearchParams } from 'react-router';
import { useDeviceSearch } from '../../hooks/useDeviceSearch';
import { writeStickyTab } from './tabConfig';

/**
 * Plan 94 Phase 6 — compatibility redirects from the old per-tool routes into the
 * device-first navigation. They keep bookmarks and in-app links working for one
 * release cycle after the navbar switches to a single "Devices" entry point.
 *
 * The old routes had no concept of "the current device" beyond the retired pin, so
 * they land on the Fleet Explorer with the tool remembered as the sticky tab — the
 * operator picks a device and opens straight onto that tool. The exception is
 * `/photos?device=<name>`, which still carries a serial and resolves to that
 * device's Photos tab.
 */

export const LegacyTabRedirect: React.FC<{ tab: string }> = ({ tab }) => {
  writeStickyTab(tab);
  return <Navigate to="/devices" replace />;
};

export const LegacyPhotosRedirect: React.FC = () => {
  const [params] = useSearchParams();
  const name = params.get('device');
  writeStickyTab('photos');

  // Resolve the serial to an RDS id via search. The hook always runs (hooks can't
  // be conditional); when there is no ?device= we redirect before reading rows.
  const { rows, loading } = useDeviceSearch(name ? { q: name, pageSize: 5 } : { pageSize: 1 });

  if (!name) return <Navigate to="/devices" replace />;
  if (loading) return null;

  const match = rows.find((r) => r.name.toLowerCase() === name.toLowerCase());
  return <Navigate to={match ? `/devices/${match.id}/photos` : '/devices'} replace />;
};
